<template>
  <AppAddUpdateModal :id="id" :title="$t($getConst.pages.pageUsers.affect_role_scopes) | capitalize">
    <template v-slot:form>
      <UserForm :modal_id="id" :userToEdit="userToEdit"/>
    </template>
  </AppAddUpdateModal>
</template>

<script>
  import UserForm from "./UserForm";
  import AppAddUpdateModal from "../../components/common/modals/AppAddUpdateModal";
  export default {
    name: "UserModal",
    components: {UserForm, AppAddUpdateModal},
    props: {
      id: null,
      userToEdit: null,
    }
  }
</script>

<style scoped>

</style>
